<template>
<div data-component="DropdownPanel.vue" class="dropdown" tabindex="0" @focusout="OnFocusOut">
	<div class="dropdown-wrapper" :class="{ 'is-visible': Visible }" :data-direction="Direction" @click.stop>
		<button class="dropdown-button" @click="OnClick">
			<slot name="button"/>
		</button>
		<div v-if="Visible" class="dropdown-panel shadow-md">
			<slot/>
		</div>
		<div/>
	</div>
	<div v-if="Visible && !Focusable" class="dropdown-backdrop" @click="OnClick"/>
</div>
</template>

<script lang="ts">
// @vuese
// Komponent odpowiedzialny za panel wyświetlany po kliknięciu przycisku.
// @group Base Components
export default {
	name: 'DropdownPanel',
	props: {
		Direction: {
			type: String,
			default: 'down left',
		},
		Focusable: {
			type: Boolean,
			default: true,
		},
	},
	emits: ['toggle'],
	data() {
		return {
			Visible: false,
		};
	},
	methods: {
		OnClick() {
			this.Toggle();
		},
		OnFocusOut(e:FocusEvent) {
			const isInside = (e.currentTarget as HTMLElement).contains(e.relatedTarget as HTMLElement);
			if (!this.Focusable || isInside) { return; }
			this.Toggle(false);
		},
		Toggle(force?:boolean) {
			const newState = typeof force === 'boolean' ? force : !this.$data.Visible;
			this.$data.Visible = newState;
			this.$emit('toggle', newState);
		},
	},
};
</script>

<style lang="scss">

.dropdown-panel {
	padding: 1.25rem;
	background: var(--white);
	border-radius: 0.5rem;
	font-size: 0.875rem;
}

.dropdown-wrapper {
	position: relative;
	display: inline-block;
	&[data-direction~="up"] .dropdown-panel { top: 0; transform: translateY(-100%); }
	&[data-direction~="down"] .dropdown-panel { bottom: 0; transform: translateY(100%); }
	&[data-direction~="left"] .dropdown-panel { left: 0; }
	&[data-direction~="right"] .dropdown-panel { right: 0; }

	&.is-visible[data-direction~="up"] .dropdown-button {
		border-top-left-radius: 0 !important;
		border-top-right-radius: 0 !important;
	}

	&.is-visible[data-direction~="down"] .dropdown-button {
		border-bottom-left-radius: 0 !important;
		border-bottom-right-radius: 0 !important;
	}
}

.dropdown-button {
	position: relative;
	z-index: 1;
}

.dropdown-wrapper .dropdown-panel {
	position: absolute;
	z-index: 2;
	background: var(--white);
}

.dropdown-backdrop {
	position: fixed;
	z-index: 1;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
}

</style>
